// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.statement-descriptor-input[data-v-75be2448] {\n  max-width: 18.375rem;\n}\n", ""]);
// Exports
module.exports = exports;
